import React from "react";
import { AppRouter } from "Routes/appRouter";
import Layout from "views/Layout";
import "./App.css";
import "bootstrap/dist/css/bootstrap.css";


function App() {
  return (
    <>
      <div className="container-gral">
        <Layout>
          <AppRouter />
        </Layout>
      </div>
    </>
  );
}

export default App;
